<template>
  <div class="main page-workspace home-page">
    <el-row :gutter="32">
      <el-col :span="10" class="home-left-col">
        <div class="index workspace-profile">
          <el-form ref="loginForm" :model="loginForm" class="index-profile">
            <div class="title">
              <img :src="avatarFilePath" class="profile-img">
            </div>
            <ul class="list-group list-group-striped">
              <li class="list-group-item" style="text-align: center;">
                <span>{{ user.userName }}</span>
                <span v-if="user.auditStatus == 0">（待认证）</span>
                <span v-if="user.auditStatus == 1">（驳回）</span>
                <span v-if="user.auditStatus == 2">（审核通过）</span>
                <span v-if="user.auditStatus == 3">（待审核）</span>
              </li>
              <li class="list-group-item" style="text-align: center;" v-if="user.address">
                <span>诊所地址：</span>
                <span>{{ user.address }}</span>
              </li>
              <li class="list-group-item">
                <svg-icon icon-class="iconPark-add-user2" />
                <span class="pull-right">本周问诊数量：{{ user.countExamChat }}人</span>
              </li>
              <li class="list-group-item">
                <svg-icon icon-class="if-prescription" />
                <span class="pull-right">本周检查人数：{{ user.countExamProject }}人</span>
              </li>
              <!--<li class="list-group-item">
                <svg-icon icon-class="farfa-money-bill-alt" />
                <span class="pull-right">销售收入：587548.24元</span>
              </li>
              <li class="list-group-item">
                <svg-icon icon-class="riLine-vip-line" />
                <span class="pull-right">合作等级：一级合作伙伴</span>
              </li>-->
            </ul>
          </el-form>
        </div>
      </el-col>
      <el-col :span="14" class="home-right-col">
        <div id="topNavigation" ref="topNavigation" class="workspace-nav">
          <el-row>
            <el-col :span="7">
              <!-- <div @click="existPermission($event)" id="0005">-->
              <div class="navigationDiv" @click="goNavigation('patient/list')">
                <svg-icon icon-class="iconPark-classroom" class="navigationSvn" />
                <div class="navigationTitle">我的患者</div>
              </div>
              <!--</div>-->
            </el-col>
            <el-col :span="7" v-if="doctorType == '0' || doctorType == '1' || doctorType == '3'" :offset="offsetVale">
              <!--<div @click="existPermission($event)" id="0001">-->
              <div class="navigationDiv" @click="goNavigation('dynamicEcg')">
                <svg-icon icon-class="stLine-cloud-upload-l" class="navigationSvn" />
                <div class="navigationTitle">动态心电上传</div>
              </div>
              <!--</div>-->
            </el-col>
            <el-col :span="7" v-if="doctorType == '0' || doctorType == '1' || doctorType == '3'" :offset="offsetVale">
              <div class="navigationDiv" @click="goNavigation('examineList')">
                <svg-icon icon-class="if-history" class="navigationSvn" />
                <div class="navigationTitle">检查记录</div>
              </div>
            </el-col>

            <el-col :span="7" v-if="doctorType == '2'" :offset="offsetVale">
              <div class="navigationDiv" @click="goNavigation('drugCopy')">
                <svg-icon icon-class="fa5-stethoscope" class="navigationSvn" />
                <div class="navigationTitle">药品复制</div>
              </div>
            </el-col>
            <el-col :span="7" v-if="doctorType == '2'" :offset="offsetVale">
              <div class="navigationDiv" @click="goNavigation('drugMaintain')">
                <svg-icon icon-class="md-location_on" class="navigationSvn" />
                <div class="navigationTitle">药品管理</div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7">
              <div class="navigationDiv" @click="goNavigation('extreme')">
                <svg-icon icon-class="iconPark-flash-payment" class="navigationSvn" />
                <div class="navigationTitle">极速问诊</div>
              </div>
            </el-col>
            <el-col :span="7" :offset="offsetVale" v-if="doctorType == '2'">
              <div class="navigationDiv" @click="goNavigation('drugExamine')">
                <svg-icon icon-class="antOutline-insurance" class="navigationSvn" />
                <div class="navigationTitle">院内处方审核</div>
              </div>
            </el-col>
            <el-col :span="7" :offset="offsetVale" v-if="doctorType == '2'">
              <div class="navigationDiv" @click="goNavigation('outsideDrugExamine')">
                <svg-icon icon-class="antOutline-insurance" class="navigationSvn" />
                <div class="navigationTitle">院外处方审核</div>
              </div>
            </el-col>
            <el-col :span="7" :offset="offsetVale" v-if="doctorType == '0' || doctorType == '1' || doctorType == '3'">
              <!--HealthScience  -->
              <div class="navigationDiv" @click="goNavigation('HealthScience')">
                <svg-icon icon-class="iconPark-preschool" class="navigationSvn" />
                <div class="navigationTitle">健康科普</div>
              </div>
            </el-col>
            <el-col :span="7" :offset="offsetVale" v-if="doctorType == '0' || doctorType == '1' || doctorType == '3'">
              <div class="navigationDiv" @click="goNavigation('activity')">
                <svg-icon icon-class="antOutline-insurance" class="navigationSvn" />
                <div class="navigationTitle">活动管理</div>
              </div>
            </el-col>
          </el-row>
          <el-row v-if="doctorType == '2' || doctorType == '3'">
            <el-col :span="7" v-if="doctorType == '2'">
              <div class="navigationDiv" @click="jdRequestCode()">
                <svg-icon icon-class="antOutline-control" class="navigationSvn" />
                <div class="navigationTitle">京东审方</div>
              </div>
            </el-col>
            <el-col :span="7" :offset="offsetVale" v-if="doctorType == '2'">
              <div class="navigationDiv" @click="goNavigation('HealthScience')">
                <svg-icon icon-class="iconPark-preschool" class="navigationSvn" />
                <div class="navigationTitle">健康科普</div>
              </div>
            </el-col>
            <el-col :span="7" :offset="offsetVale" v-if="doctorType == '3'">
              <div class="navigationDiv" @click="goNavigation('drugDelivery')">
                <svg-icon icon-class="iconPark-preschool" class="navigationSvn" />
                <div class="navigationTitle">药品配送</div>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--        <div id="bottomNavigation" ref="bottomNavigation">
          <el-row>
            <el-col :span="5">
              <div class="navigationDiv" @click="previousNavigation(2)">
                <svg-icon icon-class="md-navigate_before" class="navigationSvn"/>
                <div class="navigationTitle">上一页</div>
              </div>
            </el-col>
            <el-col :span="5" :offset="offsetVale">
              <div class="navigationDiv" @click="goNavigation('activity')">
                <svg-icon icon-class="antOutline-insurance" class="navigationSvn"/>
                <div class="navigationTitle">活动管理</div>
              </div>
            </el-col>
            <el-col :span="5" :offset="offsetVale">
              <div class="navigationDiv" @click="handleNotOpenNavigationButton">
                <svg-icon icon-class="antOutline-insurance" class="navigationSvn"/>
                <div class="navigationTitle">保险套餐</div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <div class="navigationDiv" @click="handleNotOpenNavigationButton">
                <svg-icon icon-class="md-account_balance_wallet" class="navigationSvn"/>
                <div class="navigationTitle">我的钱包</div>
              </div>
            </el-col>
            <el-col :span="5" :offset="offsetVale">
              <div class="navigationDiv" @click="handleNotOpenNavigationButton">
                <svg-icon icon-class="if-database" class="navigationSvn"/>
                <div class="navigationTitle">我的积分</div>
              </div>
            </el-col>
            <el-col :span="5" :offset="offsetVale">
              <div class="navigationDiv" @click="handleNotOpenNavigationButton">
                <svg-icon icon-class="md-shopping_cart" class="navigationSvn"/>
                <div class="navigationTitle">购买记录</div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <div class="navigationDiv" @click="handleNotOpenNavigationButton">
                <svg-icon icon-class="md-grade" class="navigationSvn"/>
                <div class="navigationTitle">我的收藏</div>
              </div>
            </el-col>
            <el-col :span="5" :offset="offsetVale">
              <div class="navigationDiv" @click="handleNotOpenNavigationButton">
                <svg-icon icon-class="iconPark-find-one" class="navigationSvn"/>
                <div class="navigationTitle">基因筛查</div>
              </div>
            </el-col>
            <el-col :span="5" :offset="offsetVale">
              <div class="navigationDiv">
                <svg-icon icon-class="md-chevron_right" class="navigationSvn"/>
                <div class="navigationTitle">下一页</div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div id="lastNavigation" ref="lastNavigation">
          <el-row>

          </el-row>
        </div>-->
      </el-col>
    </el-row>
  </div>

</template>

<script>

import Cookies from "js-cookie";
import { getInfo } from '@/api/login';
import { havingPermission } from "@/api/permission";
import { getLoginUrl, getOauthStatus } from '@/api/jdRequest'

export default {
  name: "index",
  data() {
    return {
      doctorType: sessionStorage.getItem('doctorType'),
      avatarFilePath: '',
      offsetVale: 1,
      user: {},
      agree: '',
      codeUrl: "",
      cookiePassword: "",
      loginForm: {
        username: "admin@163.com",
        password: "admin123",
        rememberMe: false,
        code: "",
        uuid: ""
      },
      loading: false,
      redirect: undefined
    };
  },
  watch: {

  },
  created() {
    this.getCookie();
    // 获得用户信息
    const adminToken = this.getToken();
    if (adminToken) {
      // 获得用户信息
      getInfo().then(response => {
        console.log("主页-获得用户信息");
        console.log(response);
        if (response.code == 0) {
          this.user = response.data;
          // 头像  response.data.avatarFilePath
          let filePath = this.downloadServer + response.data.avatarFilePath;
          this.avatarFilePath = response.data.avatarFilePath ? filePath : require("@/assets/images/profile.png");
          console.log(this.avatarFilePath, 'this.avatarFilePath')
        }
      });
    }
  },
  methods: {
    //判断权限存在
    existPermission(event) {
      let params = {
        code: event.currentTarget.id,
        systemGroup: Cookies.get("systemGroup"),
        userId: Cookies.get("id"),
      }
      console.log("aaaaaaaaaaaaaaaa");
      console.log(params);
      //查询是否有该权限
      havingPermission(params).then(response => {
        if (response.data === -1) {
          this.$message.error('您没有该权限！');
          let path = '/navigation/';
          //直接跳转
          this.$router.push(path);
        } else {
          this.$message.success('您有该权限！');
        }
      })
    },
    // 提示未开通的功能
    handleNotOpenNavigationButton() {
      this.msgError("暂未开通此功能");
      return;
    },
    getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get('rememberMe')
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password: password === undefined ? this.loginForm.password : password,
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
      };
    },
    clickItem(e) {
      e === this.agree ? this.agree = '' : this.agree = e
    },
    nextNavigation(page) {
      if (page === 1) {
        this.$refs.topNavigation.style.display = "none";
        this.$refs.bottomNavigation.style.display = "block";
        this.$refs.lastNavigation.style.display = "none";
      }
      if (page === 2) {
        this.$refs.topNavigation.style.display = "none";
        this.$refs.bottomNavigation.style.display = "none";
        this.$refs.lastNavigation.style.display = "block";
      }
    },
    previousNavigation(page) {
      if (page === 2) {
        this.$refs.topNavigation.style.display = "block";
        this.$refs.bottomNavigation.style.display = "none";
        this.$refs.lastNavigation.style.display = "none";
      }
      if (page === 3) {
        this.$refs.topNavigation.style.display = "none";
        this.$refs.bottomNavigation.style.display = "block";
        this.$refs.lastNavigation.style.display = "none";
      }
    },

    goNavigation(e) {
      if (this.user.auditStatus != '2') {
        this.msgError("未通过审核,请审核后使用此功能!");
        return;
      }
      console.log(e)
      if (e == 'shopping') {
        // location.href='https://bmall.baiyiyl.com/?tenant_id=1';
        window.open('https://bmall.baiyiyl.com/?tenant_id=1', "_blank");
        return;
      }
      if (e == 'extreme') {
        this.$confirm('只有复诊患者才能进行线上问诊', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let path = '/navigation/' + e;
          //直接跳转
          this.$router.push(path);
        })
        return;
      }
      let path = '/navigation/' + e;
      //直接跳转
      this.$router.push(path);
    },

    jdRequestCode() {
      getOauthStatus().then(response => {
        if (response.code == 0) {
          this.$router.push({ path: '/navigation/jdcheck' });
        } else {
          getLoginUrl().then(response => {
            if (response.code == 0) {
              // this.$router.push({ path: '/navigation/jdcheck' });
              location.href = "/";
              this.$router.push('/callback');
              window.location.href = response.data.url;
            }
          })
        }
      })
    }
  }
};
</script>

<style>
.main.home-page {
  margin: 0 auto;
}

.index {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.pull-right {
  margin-left: 8px;
}

#topNavigation > .el-row {
  margin-bottom: 0;
}

#bottomNavigation,
#lastNavigation {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue